import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import {
  APRs,
  CalculateBorrowAmountButton,
  CalculateMonthlyPaymentsButton,
  Calculations,
  Fields,
} from './components';
import useFinanceCalculatorForm from './useFinanceCalculatorForm';

const FinanceCalculatorForm: React.FunctionComponent = function ({}) {
  const { form, onSubmit } = useFinanceCalculatorForm();
  return (
    <Form form={form} onSubmit={onSubmit} id="finance-form">
      <FormTheme variant="streamline">
        <div className="flex flex-col rounded-lg shadow-a">
          <div className="grid grid-cols-2">
            <CalculateMonthlyPaymentsButton />
            <CalculateBorrowAmountButton />
          </div>
          <div className="flex flex-col w-full px-4 py-4 border border-t-0 border-neutral-300 rounded-b-lg">
            <APRs />
            <Fields />
            <Calculations />
          </div>
        </div>
      </FormTheme>
    </Form>
  );
};

export default FinanceCalculatorForm;
